import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import styles from "./GenerateSequenceConfirmationModal.module.css";

const GenerateSequenceConfirmationModal = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent className={styles.subHeading}>
        Do you want to schedule future Inter Plant Aggregates in the sequence?
      </DialogContent>
      <DialogActions>
        {/* Cancel */}
        <Button className={styles.cancelBt} onClick={onClose}>
          No, Proceed to Sequence
        </Button>
        {/* OK */}
        <Button
          variant="contained"
          className={styles.submitBt}
          onClick={onConfirm}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default GenerateSequenceConfirmationModal;